module.exports = __webpack_public_path__ + "75c819904e4a9add3af1f27a5e4e111a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/baoxian_h.png
// module id = 822
// module chunks = 3